module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/delete-89ff8e4588405971fdaee6a137f1b5ff.svg";